export default __webpack_public_path__ + "static/media/023.4f42c257.jpg";